// Google Analytics
export enum EventGTM {
  MakeConversions = 'addEvents_makeConversions',
  MakeActions = 'addEvents_makeActions',
  UseNavigations = 'addEvents_useNavigations',
}

export enum EventId {
  ClickBurgerMenu = 'd-v377-e1',
  ClickGoToGiftsButton = 'd-v377-e2',
  ClickOffer = 'd-v377-e4',
  ClickSubscriptionOptionButton = 'd-v377-e5',
  SendInputToGAInFormSendGiftModal = 'd-v377-e6',
  ClickCloseButtonInFormSendGiftModal = 'd-v377-e7',
  SubscriptionGiftSuccess = 'd-v377-e8',
  SubscriptionGiftFailure = 'd-v377-e9',
  ClickButtonInSubscriptionGiftFailureModal = 'd-v377-e10',
  ClickEnterServiceButtonInPromoCodeActivate = 'd-v377-e11',
  ClickActivateButtonInPromoCodeActivate = 'd-v377-e12',
  SubscriptionGiftActivateSuccess = 'd-v377-e13',
  SubscriptionGiftActivateFailure = 'd-v377-e14',
  ClickButtonInSubscriptionGiftSuccessModal = 'd-v377-e15',
  ClickMyOrdersItemMenuHeader = 'd-v377-e16',
}

export enum EventCat {
  Gift = 'podarok',
  GiftMobile = 'podarok - Mobile',
  GiftDesktop = 'podarok - Desktop',
  TilesGift = 'Tiles / podarok',
}

export enum EventName {
  OpenMenu = 'openMenu',
  Submit = 'submit',
  Submit1 = 'submit1',
  ClickElement = 'clickElement',
  ClickOffer = 'clickTile',
  ClosePopup = 'closePopUp',
  SubmitTransaction = 'submitTransaction',
  SendError = 'sendError',
  SendInput = 'sendInput',
  ClickLink = 'clickLink',
}

export function trackEventBound(
  event: EventGTM,
  eventId: EventId,
  eventCat: EventCat,
  eventName: EventName,
  eventParam: string
) {
  try {
    // @ts-ignore
    window.dataLayer.push({
      event,
      event_id: eventId,
      event_cat: eventCat,
      event_name: eventName,
      event_param: eventParam,
    });
    // eslint-disable-next-line no-empty
  } catch (e) {}
}
